import 'alpinejs'


function createDoughnutChart(ctx) {
    var hydroProduction = parseInt(ctx.getAttribute('data-hydro'));
    var nuclearProduction = parseInt(ctx.getAttribute('data-nuclear'));
    var windProduction = parseInt(ctx.getAttribute('data-wind'));
    var thermalProduction = parseInt(ctx.getAttribute('data-thermal'));
    var unspecifiedProduction = parseInt(ctx.getAttribute('data-unspecified'));

    var totalProduction = hydroProduction + nuclearProduction + windProduction + thermalProduction + unspecifiedProduction;

    var partHydro = (hydroProduction/totalProduction) * 100.0;
    var partNuclear = (nuclearProduction/totalProduction) * 100.0;
    var partWind = (windProduction/totalProduction) * 100.0;
    var partThermal = (thermalProduction/totalProduction) * 100.0;
    var partUnspecified = (unspecifiedProduction/totalProduction) * 100.0;

    var productionChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            datasets: [{
                data: [
                    hydroProduction, 
                    nuclearProduction, 
                    windProduction,
                    thermalProduction,
                    unspecifiedProduction
                ],
                backgroundColor: [
                    '#00c0ef',
                    '#f39c12',
                    '#00a65a',
                    '#dd4b39',
                    '#000000'
                ]
            }],
            labels: [
                'Vattenkraft ('+(Math.round(partHydro * 100) / 100).toFixed(1)+'%)',
                'Kärnkraft ('+(Math.round(partNuclear * 100) / 100).toFixed(1)+'%)',
                'Vindkraft ('+(Math.round(partWind * 100) / 100).toFixed(1)+'%)',
                'Värmekraft ('+(Math.round(partThermal * 100) / 100).toFixed(1)+'%)',
                'Ospecificerat ('+(Math.round(partUnspecified * 100) / 100).toFixed(1)+'%)'
            ]
        },
        options: {
            maintainAspectRatio: false,
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + ' MW';
                    }
                }
            }
        }
    });      
}
